<template>
<div class="container-fluid bg-white">
	<toolbar>
		<router-link to="/financial" class="btn btn-link">
			<i class="fa fa-caret-left fa-2x"></i>
			<h2>Financial</h2>
		</router-link>

		<div class="controls"></div>

	</toolbar>

	<purchase-orders :is-main-list="true" main-list-path="/financial/purchase-orders" :selected-po-slug="poSlug"></purchase-orders>

</div>
</template>

<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"

import PurchaseOrders from "@/pages/project/PurchaseOrders"

export default {
	name: "PurchaseOrdersFinancial",
	components: {
		Toolbar,
		PurchaseOrders
	},
	data() {
		return {
			poSlug: null
		}
	},
	created() {
		console.log(this.$route.params)
		if ("po_slug" in this.$route.params)
			this.poSlug = this.$route.params.po_slug
	}
}
</script>